/** 
 * api接口的统一出口
 */
import { login } from './api/login';
import { coach } from './api/coach';
import { student } from './api/student';
import { train } from './api/train'
import { dicts } from './api/dict'
import { upload } from './api/upload'
// 其他模块的接口……

// 导出接口
export default {
    login,
    coach,
    dicts,
    student,
    train,
    upload
}
